import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "./hooks/ProtectedRoute";
import { PublicRoute } from "./hooks/PublicRoute";
import Contingency from "./views/private/Contingency/Contingency";
import HomeDashboard from "./views/private/Dashboard/HomeDashboard";
import EditModel from "./views/private/Models/EditModel/EditModel";
import { Models } from "./views/private/Models/Models";
import OrderDetails from "./views/private/Orders/EditOrder/OrderDetails";
import Orders from "./views/private/Orders/Orders";
import { PartsPricing } from "./views/private/PartsPricing/PartsPricing";
import { Payments } from "./views/private/Payments/Payments";
import Price from "./views/private/Price/Price";
import Services from "./views/private/Services/Services";
import ServiceTemplates from "./views/private/ServicesTemplates/ServiceTemplates";
import { Users } from "./views/private/Users/Users";
import LandingPage from "./views/public/LandingPage";
import { Login } from "./views/public/Login";
import NotFound from "./views/public/NotFound";
import FormattedInputs from "./views/Test";

export function AppRoutes() {
	return (
		<Routes>
			<Route element={<PublicRoute />}>
				<Route path="/" element={<LandingPage />} />
				<Route path="/login" element={<Login />} />
			</Route>
			<Route element={<ProtectedRoute />}>
				<Route path="/home" element={<HomeDashboard />} />

				<Route path="/payments" element={<Payments />} />
				<Route path="/servicos" element={<Services />} />
				<Route path="/presets" element={<ServiceTemplates />} />

				<Route path="/modelos" element={<Models />} />
				<Route
					path="/modelos/:manufacturerId/:modelId"
					element={<EditModel />}
				/>
				<Route path="/price" element={<Price />} />
				<Route path="/orders" element={<Orders />} />
				<Route path="/orders/:id" element={<OrderDetails />} />
				<Route path="/pricing" element={<PartsPricing />} />
				<Route path="/users" element={<Users />} />
				<Route path="/contingencias" element={<Contingency />} />
				<Route path="/testes" element={<FormattedInputs />} />
			</Route>
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}
